<template>
  <div>
    <div
        v-for="(item, idx) in itemsToRefund"
        :key="idx"
        v-bind="item"
        class="refund-items">
      <div class="flex flex-col">
        <div class="flex flex-row">
          <div class="flex-1">
            {{ item.stripe_order_item.productTitle }}
          </div>
          <div class="refund-amount">
            {{ item.refundType === "tax" ? "Tax refund:" : "Custom refund:" }}
            &nbsp;
            <span>
              {{ formattedAmount(item.refundAmount, "USD") }}
              <span
                  v-if="item.refundType === 'partial'">(+ applicable taxes)</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
        v-if="refundShipping"
        class="refund-items">
      <div class="flex flex-col">
        <div class="flex flex-row">
          <div class="flex-1">
            Shipping Costs
          </div>
          <div class="refund-amount">
            Shipping refund: &nbsp;
            <span>{{ formattedAmount(shippingTotal, "USD") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from "numeral";
import { CURRENCY_SYMBOLS } from "@/constants";

export default {
  name: "ItemRefundSummaryList",
  props: {
    itemsToRefund: {
      type: Array,
      required: true,
    },
    refundShipping: {
      type: Boolean,
      default: false,
    },
    shippingTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    formattedAmount(amount, currency) {
      var neg = false;
      if (amount < 0) {
        neg = true;
        amount = -amount;
      }

      amount = numeral(amount).format(`0,0.00`);
      return `${neg ? "– " : ""}${
        CURRENCY_SYMBOLS[currency || "USD"]
      }${amount}`;
    },
  },
};
</script>
<style scoped>
.refund-amount {
  min-width: 250px;
  display: flex;
  justify-content: space-between;
}
.refund-items {
  margin-top: 4px;
}
</style>
